import {Divider, List, ListItem, ListItemText, SwipeableDrawer} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import {useSelector} from "../../store";
import {isAuthenticated, selectApplets} from "../../reducer/iam/authReducer";

const useStyles = makeStyles({
    drawerPaper: {
        top: 50
    }
});

const CustomItemText = (props) => {
    const {primary, onClick} = props;
    return <ListItemText primary={i18n.translate(primary)} onClick={onClick}/>
}

function DrawerMenu(props) {
    const {onClose = () => {}, onOpen = () => {}, open = false} = props;
    const classes = useStyles();
    const history = useHistory();
    const authenticated = useSelector(isAuthenticated);
    const applets = useSelector(selectApplets);

    const handleCustomItemTextClick = path => () => {
        onClose();
        history.push(path)
    }

    const appletsItems = authenticated ? applets.map((applet, index) => (
        <ListItem button key={index}>
            <CustomItemText onClick={handleCustomItemTextClick(applet.path)} primary={applet.text} />
        </ListItem>
    )) : null;

    const list = () => (
        <div
            role="presentation"
            onKeyDown={onClose}
            style={{width: "auto"}}
        >
            <List>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/courseAnnouncement')} primary={'Course announcement'} />
                </ListItem>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/courseFee')} primary={'Course Fee'} />
                </ListItem>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/courseBrief')} primary={'Course Brief'} />
                </ListItem>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/contactUs')} primary={'Contact Us'} />
                </ListItem>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/trafficInfo')} primary={'Traffic Information'} />
                </ListItem>
                <ListItem button>
                    <CustomItemText onClick={handleCustomItemTextClick('/otherInfo')} primary={'Other Information'} />
                </ListItem>
            </List>
            <Divider/>
            {!authenticated ?
                <List>
                    <ListItem button>
                        <CustomItemText onClick={handleCustomItemTextClick('/logon')} primary={'Login'} />
                    </ListItem>
                    <ListItem button>
                        <CustomItemText onClick={handleCustomItemTextClick('/registration')} primary={'Register'} />
                    </ListItem>
                    <ListItem button>
                        <CustomItemText onClick={handleCustomItemTextClick('/newLecturer')} primary={'New Lecturer'} />
                    </ListItem>
                </List> : <List>{appletsItems}</List>
            }
        </div>
    );

    return (
        <SwipeableDrawer onClose={onClose} onOpen={onOpen}
                         classes={{paper: classes.drawerPaper}}
                         open={open} style={{ zIndex: 800 }} anchor={"top"}>
            {list()}
        </SwipeableDrawer>
    );
}

export default DrawerMenu;